<script setup lang="ts">
const route = useRoute()

const layout = computed(() => {
  return route.meta.layout ?? ''
})
</script>

<template>
  <component :is="layout" v-if="layout" />
  <router-view v-else />
</template>
